import { render, staticRenderFns } from "./WizardStep.vue?vue&type=template&id=47a5a31a&scoped=true&lang=pug&"
import script from "./WizardStep.vue?vue&type=script&lang=ts&"
export * from "./WizardStep.vue?vue&type=script&lang=ts&"
import style0 from "./WizardStep.vue?vue&type=style&index=0&id=47a5a31a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a5a31a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\as3-portals\\AS3.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47a5a31a')) {
      api.createRecord('47a5a31a', component.options)
    } else {
      api.reload('47a5a31a', component.options)
    }
    module.hot.accept("./WizardStep.vue?vue&type=template&id=47a5a31a&scoped=true&lang=pug&", function () {
      api.rerender('47a5a31a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wizard-pages/WizardStep.vue"
export default component.exports